import React from 'react';
import Container from '../Container/Container';

import list from '../../JSON/newItems.json';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';
import s from './newItems.module.css';

export default function NewItems() {
  return (
    <div className={s.wrapper}>
      <Container>
        <ul className={s.list}>
          {list.map(({ id, img, title, description, path }) => (
            <li key={id} className={s.item}>
              <img className={s.img} src={img} alt="images" />
              <div className={s.wrapperDescription}>
                {' '}
                <h3 className={s.title}>{title}</h3>
                <p className={s.texz}>{description}</p>
              </div>
              <div className={s.overlay}>
                <Link to={`${path}/${id}`}>
                  <Button
                    className={s.button}
                    name={'Детальніше'}
                    width="163px"
                  />
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
}
